import { styled } from "@mui/material";
import { FileUploader as LibFileUploader } from "react-drag-drop-files";
import Modal from "./Modal";

const fileTypes = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "hwp",
  "png",
  "jpg",
  "mp3",
  "m4a",
  "wav"
];

const FileZone = styled("div")`
  padding: 40px 20px;
  text-align: center;
  border: 2px dashed gray;
  border-radius: 15px;
  cursor: pointer;
  margin-bottom: 80px;
  :hover {
    background-color: #f6f6f6;
  }
`;

const FileUploader = ({
  open,
  handleChange,
  handleClose
}: {
  open: boolean;
  handleChange: (files: File[]) => void;
  handleClose: () => void;
}) => {
  return (
    <Modal isView={open} title={"파일업로드"} cancelAction={handleClose}>
      <LibFileUploader
        handleChange={handleChange}
        name="file"
        label="파일 첨부를 위해 클릭하거나 파일을 끌어다 놓아 주세요."
        types={fileTypes}
        multiple
      >
        <FileZone>
          <div>
            파일첨부를 위해 <b>클릭</b>하거나 파일을 <b>끌어다 놓아</b> 주세요.
          </div>
          <div>
            권장크기 : 5MB 이내, 확장자 : pdf, doc, docx, xls, xlsx, ppt, pptx,
            hwp, png, jpg, mp3, m4a, wav
          </div>
        </FileZone>
      </LibFileUploader>
    </Modal>
  );
};

export default FileUploader;
